import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography,IconButton } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { YES_NO } from '../../../../../constants';

export const ObstericDetailsForm = ({ onAdd, onClose, setObstericHistoryDialog}) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
       
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = (formValue) => {
    onAdd(formValue);
    setObstericHistoryDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
         <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" sx={{ marginBottom:2,borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{marginBottom:"2%"}}>
          Obsteric Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
    <Grid container spacing={2}>
  <Grid item xs={12}>
    <Stack spacing={2}>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>G</Typography>
        <TextField sx={{ flex: 1 }} name="g"   />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>P</Typography>
        <TextField sx={{ flex: 1 }} name="p"  />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>L</Typography>
        <TextField sx={{ flex: 1 }} name="l"  />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>MTP</Typography>
        <TextField sx={{ flex: 1 }} name="mtp"  />
      </Stack>
    </Stack>
  </Grid>

</Grid>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
